import { render } from "./SFaceUsedLowerDefaultContent.vue?vue&type=template&id=3bb7df36&scoped=true"
import script from "./SFaceUsedLowerDefaultContent.vue?vue&type=script&lang=js"
export * from "./SFaceUsedLowerDefaultContent.vue?vue&type=script&lang=js"

import "./SFaceUsedLowerDefaultContent.vue?vue&type=style&index=0&id=3bb7df36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bb7df36"

export default script